import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { SHARED_LINK_LABEL } from "src/utils/commentMentions";

const CommentLink = ({ href, label = SHARED_LINK_LABEL }) => {
  const [hovered, setHovered] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <span
      className="comment-link-cell"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <a href={href} className="comment-link" onClick={handleClick}>
        <span className="comment-link__text">{label}</span>
      </a>
      {hovered && (
        <Icon name="arrow up right" className="comment-link-hover-icon" />
      )}
    </span>
  );
};

export default CommentLink;
